module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABVElEQVRIibWVfZKDIAzFf9npveBmhJuFk739A22xFqvt7pthoiHmST6ISQKg1tofJiil2NH+FJJwd3UwXYvN3GCyzN2Vcz71MxFx+YQ3gJTSKYIjOzOTpB3Jz2BCa+1j6d5Jdsxr/CNCEh9LdwTs8rRJ8DckMwJzd5VSaK2RUqa1OEzmFbh7TzJwd55SJsI5W1nvcCdYnbcWQACQc7x1IBXMrIdjkGsU7lU0nuAKzOylPHWCiDNkcbg7zUHXnWvAV+g9MoRoe4K/w7kcmFGH2NrkXrW637iBU6svr5ldC5iBgPFbPUj0dDlYNVQG5TIPNC53X7pU8u6jy7Xnu+puI0k4Qmg1iwgB+llIbFzjH+UIKlDWwWSViIZTiec+qYBPynSGlBJpiENR6XptK2wTlisEtdaH81Iu6TrzizE35uBTbHLwnzgM0dqN38D0XMhMRt+H+AX0+QzB1KpIvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/PROGRAMS.png
// module id = 91
// module chunks = 0